import {AuthWebservice} from './auth.webservice';
import {Router} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {SessionService} from '../session.service';
import {CurrentUserService} from '../current-user.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutWebservice {
  private readonly currentUserService = inject(CurrentUserService);
  private readonly authService = inject(AuthWebservice);
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);


  logout() {
    this.currentUserService.currentUser = null;
    this.authService.signOutUser();
    this.sessionService.reset();
    this.router.navigate(['']);
  }
}
